export default `
    <div class="pop-up-pane-container #= data.containerClasses # #=data.bsc||""#" id="#= data.id #">
        <div class="pop-up-pane">
            <div class="pop-up-pane-header">
                <span class="pop-up-pane-title #=data.bindClass#" data-bind="text: #= data.title #">
                </span>
                <span class="pop-up-pane-other-info">
                    #= (data.otherInfo ? data.otherInfo : "") #
                </span>
                # if (data.info) {#
                    <span class="large-info mar-l-5"></span>
                # } #
            </div>
            <div class="pop-up-pane-body container #= data.classes #">
                #= data.components #
            </div>
        </div>
    </div>
`;
